import React from "react";
import classNames from "classnames";
import styles from "./style.scss";

export const Paragraph = ({ children, lead, align, noMargin }) => {
    return (
        <p
            className={classNames(styles.base, {
                [styles.lead]: lead,
                [styles.centerAlign]: align === "center",
                [styles.rightAlign]: align === "right",
                [styles.noMargin]: noMargin
            })}
        >
            {children}
        </p>
    );
};
